<ng-container>
  <mat-form-field [formGroup]="form" class="form-field form-field-full-width" *ngIf="language && !menuPresentation">
    <mat-label [innerHTML]="'$login_card_language_label' | translate">$login_card_language_label</mat-label>
    <mat-select [formControl]="languageControl">
      <mat-option *ngFor="let key of language" [value]="key.culture">{{ key.label | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <ng-container *ngIf="menuPresentation">
    <span class="link" [matMenuTriggerFor]="menu" [innerHTML]="'$login_card_change_language_label' | translate"></span>
    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let key of language" (click)="languageSelected(key.culture)">{{ key.label | translate }}</button>
    </mat-menu>
  </ng-container>
</ng-container>